import ShoppinglistClient from './clients/ShoppinglistClient';
import ShoppinglistOverlayRows from './shoppinglists-overlay-rows';
import { displaySuccessFeedbackMessage } from './utilities';

export default class ShoppinglistTablesOverlay
{
    constructor()
    {
        // API
        this.shoppingListClient = new ShoppinglistClient();

        // Elements
        this.body = document.querySelector('body');
        this.shoppingListoverlay = this.body.querySelector('.js-overlay-shoppinglist-tables');
        this.overlayNewListInput = this.shoppingListoverlay.querySelector('.js-overlay-shoppinglist-new-list-input');
        this.overlayAddListButton = this.shoppingListoverlay.querySelector('.js-overlay-shoppinglist-add-list-button');
        this.overlayAddProductsButton =
            this.shoppingListoverlay.querySelector('.js-overlay-shoppinglist-products-button');
        this.overlayCloseButton = this.shoppingListoverlay.querySelector('.js-overlay-shoppinglist-close-button');
        this.overlayListContainer = this.shoppingListoverlay.querySelector('.js-overlay-shoppinglist-list-container');
        this.overlayItemCount = this.shoppingListoverlay.querySelector('.js-overlay-shoppinglist-item-count');
        this.errorInputContainer = this.body.querySelector('.js-add-list-error');
        this.errorInputFeedback = this.body.querySelector('.js-add-list-feedback-error');

        // Helper
        this.shoppingListOverlayRows = new ShoppinglistOverlayRows(this.shoppingListoverlay);
        this.productsMovedToShoppingListEvent = new Event('products-moved-to-shoppinglist');
        this.defaultShoppingList = document.querySelector('meta[name="default_shopping_list_id"]');
        this.newShoppingListId = null;
        this.productList = {};
    }

    init()
    {
        this.initEvents();
    }

    initEvents()
    {
        this.overlayNewListInput.addEventListener('click', this.showAddList.bind(this));
        this.overlayListContainer.addEventListener('click', this.showAddProduct.bind(this));
        this.overlayAddListButton.addEventListener('click', this.addNewList.bind(this));
        this.overlayAddProductsButton.addEventListener('click', this.addProductsToList.bind(this));
        this.overlayNewListInput.addEventListener('input', this.checkInput.bind(this));
        this.shoppingListoverlay.querySelector('a.close').addEventListener('click', this.hideOverlay.bind(this));
        this.overlayCloseButton.addEventListener('click', this.hideOverlay.bind(this));
        this.body.addEventListener(orion.constants.EventFocusOverlayClicked, this.hideOverlay.bind(this));
    }

    initOverlay(items)
    {
        this.productList = items;
        this.overlayItemCount.innerText = Object.keys(items).length;
        this.shoppingListOverlayRows.init();
        this.showOverlay();
    }

    addProductsToList()
    {
        let currentShoppingListId = this.newShoppingListId
            ? this.newShoppingListId
            : this.overlayListContainer.querySelector('input[name=shoppinglist]:checked').value;

        let data = this.prepareBodyData(this.productList);

        this.shoppingListClient.updateItems(data, currentShoppingListId).then(() =>
        {
            let keepItemsCheckbox = this.shoppingListoverlay.querySelector('.js-shoppinglist-keep-items')
                ? this.shoppingListoverlay.querySelector('.js-shoppinglist-keep-items')
                : null;

            if (keepItemsCheckbox && !keepItemsCheckbox.checked)
            {
                document.dispatchEvent(this.productsMovedToShoppingListEvent);
            }

            displaySuccessFeedbackMessage('content.save.to.shoppinglist.ok', '', true);
            this.newShoppingListId = null;
            this.hideOverlay();
        });
    }

    addNewList()
    {
        let name = this.overlayNewListInput.value;
        let defaultShoppingListId = this.defaultShoppingList.getAttribute('content');

        let data = {
            'name': name,
            'isDefault': !defaultShoppingListId ? true : false
        };

        if (name !== '')
        {
            this.shoppingListClient.createShoppinglist(data)
                .then((response) => response.json())
                .then((json) =>
                {
                    displaySuccessFeedbackMessage('content.shoppinglist.new.ok~tables', '', true);
                    this.overlayNewListInput.value = '';

                    if (!defaultShoppingListId)
                    {
                        this.defaultShoppingList.setAttribute('content', json.productItemListId);
                        $('body').trigger(orion.constants.EventShoppingListDefaultUpdated);
                    }

                    this.newShoppingListId = json.productItemListId;

                    let currentShoppingListId = this.newShoppingListId
                        ? this.newShoppingListId
                        : this.overlayListContainer.querySelector('input[name=shoppinglist]:checked').value;

                    let data = this.prepareBodyData(this.productList);

                    this.shoppingListClient.updateItems(data, currentShoppingListId).then(() =>
                    {
                        let keepItemsCheckbox = this.shoppingListoverlay.querySelector('.js-shoppinglist-keep-items')
                            ? this.shoppingListoverlay.querySelector('.js-shoppinglist-keep-items')
                            : null;

                        if (keepItemsCheckbox && !keepItemsCheckbox.checked)
                        {
                            document.dispatchEvent(this.productsMovedToShoppingListEvent);
                        }

                        this.newShoppingListId = null;
                        this.hideOverlay();
                    });
                });
        }
        else
        {
            this.errorInputContainer.classList.add('error', 'missing');
            this.errorInputFeedback.classList.remove('hidden');
        }
    }

    prepareBodyData(products)
    {
        let productItems = [];

        for (let productNumber in products)
        {
            let object = {
                productNumber: productNumber,
                quantity: products[productNumber]
            };

            productItems.push(object);
        }

        return {
            'productItems': productItems
        };
    }

    checkInput()
    {
        if (this.overlayNewListInput.value !== '')
        {
            this.errorInputContainer.classList.remove('error', 'missing');
            this.errorInputFeedback.classList.add('hidden');
        }
    }
    showAddProduct()
    {
        this.overlayAddListButton.classList.add('hidden');
        this.overlayAddProductsButton.classList.remove('hidden');
        this.overlayListContainer.classList.remove('list-disabled');
        this.errorInputContainer.classList.remove('error', 'missing');
        this.overlayNewListInput.value = '';
        this.errorInputFeedback.classList.add('hidden');
    }

    showAddList()
    {
        this.overlayAddListButton.classList.remove('hidden');
        this.overlayAddProductsButton.classList.add('hidden');
        this.overlayListContainer.classList.add('list-disabled');
    }

    showOverlay()
    {
        this.showAddProduct();
        this.body.classList.add('no-scroll', 'focus-active');
        this.shoppingListoverlay.classList.remove('hidden');
    }

    hideOverlay()
    {
        this.body.classList.remove('no-scroll', 'focus-active');
        this.shoppingListoverlay.classList.add('hidden');
    }
}
